class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.form.querySelector('[name=id]').disabled = false;
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.submitButton = this.querySelector('[type="submit"]');

    document.addEventListener("variantselect:render:before", () => {
      this.submitButton.classList.add("loading");
    });
  }

  onSubmitHandler(event) {
    event.preventDefault();

    this.submitButton.classList.add('loading');

    let formData = {
      items: [
        {
         id: this.form.querySelector('[name=id]').value,
         quantity: 1,
         properties: {}
        }
      ]
    }

    const properties = this.querySelectorAll('.product__property');

    properties.forEach(property => {
      const propertyName = property.getAttribute('data-name');
      const propertyValue = property.value;
      formData.items[0].properties[propertyName] = propertyValue;
    });

    fetch("/cart/add", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      })
      .then((response) => response.text())
      .then((cart) => {
        document.dispatchEvent(new CustomEvent("addtocart"));
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
      });
  }
}

customElements.define('product-form', ProductForm);

class VariantSelect extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("change", (event) => {
      this.onVariantChange(event);
    });
  }

  async onVariantChange(event) {
    const options = this.querySelectorAll("select");

    const selected_options = Array.from(options).map((element) => {
      return element.value;
    });

    const selected_variant_title = selected_options.join(" / ");

    let selected_variant = null;

    Theme.Liquid.product.variants.forEach((variant) => {
      if (variant.title == selected_variant_title) {
        selected_variant = variant;
      }
    });

    document.title = this.getTitleText(selected_variant);

    await this.render(selected_variant);
  }

  async render(variant) {
    document.dispatchEvent(
      new CustomEvent("variantselect:render:before")
    );

    const container = document.getElementById("MainProduct");

    const section_url = `${location.pathname}/?variant=${variant.id}&section_id=${container.dataset.section}`;

    const response = await fetch(section_url);
    const responseText = await response.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(responseText, "text/html");

    var section = doc.getElementById("MainProduct");

    container.replaceWith(section);

    window.history.replaceState('', '', `${location.pathname}?variant=${variant.id}`);
  }

  getTitleText(variant) {
    return `${Theme.Liquid.product.title.replace("iPhone Case", "")} ${variant.title} Case – Wildflower Cases`;
  }
}

customElements.define("variant-select", VariantSelect);
